// extracted by mini-css-extract-plugin
module.exports = {"card":"managebooking_card__1sKg0","editIcon":"managebooking_editIcon__2vlli","list":"managebooking_list__30no7"};